import { BaseApiService } from './BaseApiService';

const MAX_FOOTER_ACTIVITIES = 4;
const MAX_MUNICIPALITY_DOCUMENTS = 6;

export class WebService extends BaseApiService {
  constructor() {
    super();
    this.api = this.instance;
  }

  municipalities() {
    return this.api.get('/web/municipalities');
  }

  years() {
    return this.api.get('/web/years');
  }

  async municipalitiesById(municipalityId) {
    const { data } = await this.api.get(
      `/web/municipalities/${municipalityId}`,
    );

    if (!data || !data.info) return;

    const { info } = data;

    return {
      id: data.id,
      // Generic
      name: data.name,
      code: data.code,
      address: info.address,
      url: info.web_address,
      mapImageUrl: info.map_image_path,
      email: info.email_address,
      fax: info.fax_number,
      phone: info.business_phone,
      description: info.description,
      units: info.units,
      area: info.area,
      inhabitants: info.inhabitants,
      population: info.population,

      // Mayor
      mayor: info.mayor,
      mayorEmail: info.mayor_email_address,

      // SMG Coordinator
      smgCoordinator: info.smg_coordinator,
      smgCoordinatorEmail: info.smg_coordinator_email_address,

      // Executing Officer
      executingOfficer: info.executing_officer,
      executingOfficerEmail: info.executing_officer_email_address,

      // Documents
      policyDocuments: data.policy_documents
        .map(d => ({
          id: d.id,
          title: d.title,
          url: d.pdf_path,
        }))
        .slice(0, MAX_MUNICIPALITY_DOCUMENTS),
      keyDocuments: data.key_documents
        .map(d => ({
          id: d.id,
          title: d.title,
          url: d.pdf_path,
        }))
        .slice(0, MAX_MUNICIPALITY_DOCUMENTS),
    };
  }

  async footerActivities() {
    const response = await this.api.get(`/web/activity`);

    if (!response?.data) return;

    return {
      data: response.data.slice(0, MAX_FOOTER_ACTIVITIES).map(item => ({
        id: item.id,
        description: item.label,
        date: item.formatted_time,
      })),
    };
  }

  async search(keyword, page) {
    // ​/api​/web​/search?lang_id={lang_id}&keyword={keyword}

    const emptyResult = {
      submitted: true,
      pageSize: 0,
      pageTotal: 0,
      total: 0,
      items: [],
    };

    if (!keyword) return { ...emptyResult, submitted: false };

    const data = await this.api.get(`/web/search`, {
      params: {
        keyword,
        page,
      },
    });

    if (!data) return emptyResult;

    return {
      submitted: true,
      pageSize: data.per_page,
      total: data.total,
      pageTotal: data.last_page,
      items: (data.data || []).map(item => ({
        id: item.id,
        categoryId: item.category_id,
        categoryTitle: item.category_title,
        url: item.pdf_path,
        type: item.type,
        title: item.title,
        description: item.description,
        time: item.time,
        timeFormatted: item.formatted_time,
      })),
    };
  }

  searchGenerateUrl(searchItem) {
    const { categoryId, id, type } = searchItem;

    switch (type) {
      case 'regulation':
        return `/legislation?actPage=1&category=${categoryId}&regPage=1&regulation=${id}`;

      case 'legistlation':
        return `/legislation?actPage=1&category=${categoryId}&regPage=1&act=${id}`;

      case 'report':
        return `/reports?category=${categoryId}&id=${id}`;

      case 'news':
        return `/latest-news/${id}`;

      default:
        return '';
    }
  }
}
